export default __webpack_public_path__ + "static/media/pin.fc4a7fec.png";